import { atom } from 'recoil'

export default atom({
    key: 'viewFeatures',
    default: { pdf: false, shapefile: false, isolines: false, vectorlines: false },
})
